import { type FunctionComponent, type PropsWithChildren } from 'react';
import { PageContainer } from '../../../components/common-components/page/page-container/page-container.component';
import { getSeoMetaData } from '../../../helpers/construct/page-content.helper';
import { useRouteParams } from '../../../hooks/routing/params.hook';
import { type SeoMetaDataContent } from '../../../types/construct.types';

type LandingPageContainerProps = {
	seo: SeoMetaDataContent;
	topContent?: JSX.Element; // content to render above the page container
};

export const LandingPageContainer: FunctionComponent<PropsWithChildren<LandingPageContainerProps>> = ({ seo, children, topContent }) => {
	const { title, description, isIndexed } = getSeoMetaData(seo);
	const params = useRouteParams<{ '*': string }>();
	const pageName = params['*'];
	return (
		<>
			{topContent}
			<PageContainer canonicalURL={String(pageName)} pageTitle={title} metaDescription={description} shouldBlockIndexing={!isIndexed}>
				<>{children}</>
			</PageContainer>
		</>
	);
};
